import React from 'react';
import Session from '../../../services/Session';
import Signals from '../../../signals/Signals';
import AssetsFilters from './AssetsFilters';
import { useIntl } from 'react-intl';
import CreateManualAssetOverlay from './CreateManualAssetOverlay';
import AssetsViewState from '../../../data/AssetsViewState';
import TableSettingsOverlay from "../../components/ui/TableSettingsOverlay/TableSettingsOverlay";
import { ExportButton } from "../../components/ui/ExportButton/ExportButton";
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function AssetsControls(props) {
    var tableModel = props.tableModel, assetCollection = props.assetCollection, viewState = props.viewState, hideViewControls = props.hideViewControls, hideFilterControls = props.hideFilterControls, hideExportControls = props.hideExportControls;
    var intl = useIntl();
    return React.createElement(React.Fragment, null,
        !hideFilterControls &&
            React.createElement(AssetsFilters, { className: (viewState == AssetsViewState.MAPHORIZONTAL ? " order-last" : " "), assetCollection: assetCollection }),
        React.createElement("div", { className: "d-flex justify-content-end align-items-center flex-wrap button-grid" },
            Session.user && Session.user.isOwner &&
                React.createElement("div", { className: "nav btn-group h-100" },
                    React.createElement("button", { className: "btn btn-white", type: "button", id: "createManualAssetButton", title: intl.formatMessage({ id: 'manual.asset.create.label' }), onClick: function () {
                            Signals.ShowOverlay.dispatch(React.createElement(CreateManualAssetOverlay, null));
                        } },
                        React.createElement("span", { className: "fe fe-plus-circle" }))),
            !hideExportControls && React.createElement(ExportButton, { onClick: function (event, type) {
                    assetCollection.export(type, intl);
                } }),
            !hideViewControls &&
                React.createElement("div", { className: "nav btn-group flex-nowrap" },
                    React.createElement("button", { className: 'btn btn-white' + (viewState === AssetsViewState.TABLE ? ' active' : ''), onClick: function () {
                            Signals.ChangeAssetViewState.dispatch(AssetsViewState.TABLE);
                        } },
                        React.createElement("span", { className: "fe fe-list" })),
                    React.createElement("button", { className: "btn btn-white px-1" + (viewState === AssetsViewState.MAPHORIZONTAL ? ' active' : ''), onClick: function () {
                            Signals.ChangeAssetViewState.dispatch(AssetsViewState.MAPHORIZONTAL);
                        } },
                        React.createElement("div", { className: "d-flex flex-row" },
                            React.createElement("span", { className: "fe fe-list" }),
                            React.createElement("span", { className: "fe fe-map" }))),
                    React.createElement("button", { className: "btn btn-white py-1" + (viewState === AssetsViewState.MAPVERTICAL ? ' active' : ''), onClick: function () {
                            Signals.ChangeAssetViewState.dispatch(AssetsViewState.MAPVERTICAL);
                        } },
                        React.createElement("div", { className: "d-flex flex-column" },
                            React.createElement("span", { className: "fe fe-list" }),
                            React.createElement("span", { className: "fe fe-map" })))),
            tableModel &&
                React.createElement("div", { className: "nav btn-group h-100" },
                    React.createElement("button", { className: "btn btn-white", type: "button", id: "tableSettings", onClick: function () {
                            Signals.ShowOverlay.dispatch(React.createElement(TableSettingsOverlay, { tableModel: tableModel }));
                        } },
                        React.createElement("span", { className: "fe fe-settings" })))));
}
AssetsControls.defaultProps = {
    viewState: AssetsViewState.TABLE
};
